import React from 'react';
import useWindowSize from 'utils/hooks/useWindowSize';

const financeSolutionsCards = [
  {
    id: 0,
    title: 'Invoice Factoring',
    image: () => (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_1551_18584)">
          <rect x="0.419922" width="40" height="40" rx="8" fill="white" fillOpacity="0.04" />
          <path
            d="M28.4199 15H23.4199V10L28.4199 15ZM23.4199 16.25H28.4199V28.125C28.4199 29.1605 27.5805 30 26.5449 30H15.2949C14.2594 30 13.4199 29.1602 13.4199 28.125V11.875C13.4199 10.8395 14.2594 10 15.2949 10H22.1699L22.1701 15C22.1699 15.6914 22.7285 16.25 23.4199 16.25ZM15.9199 13.4375C15.9199 13.6086 16.0617 13.75 16.2324 13.75H19.3574C19.5293 13.75 19.6699 13.6086 19.6699 13.4375V12.8125C19.6699 12.6418 19.5293 12.5 19.3574 12.5H16.2324C16.0617 12.5 15.9199 12.6418 15.9199 12.8125V13.4375ZM16.2324 16.25H19.3574C19.5293 16.25 19.6699 16.1094 19.6699 15.9375V15.3125C19.6699 15.1406 19.5293 15 19.3574 15H16.2324C16.0617 15 15.9199 15.1406 15.9199 15.3125V15.9375C15.9199 16.1094 16.0617 16.25 16.2324 16.25ZM21.1348 22.375L20.8848 22.3125C19.9941 22.0391 20.0137 21.8789 20.0449 21.7383C20.0986 21.4331 20.693 21.3586 21.2273 21.4404C21.4459 21.4734 21.6855 21.5503 21.9145 21.6296C22.3203 21.77 22.7672 21.5539 22.9086 21.1476C23.0502 20.7398 22.8347 20.2945 22.427 20.1527C22.145 20.0557 21.9148 19.9934 21.702 19.9467V19.6875C21.702 19.2566 21.3522 18.9062 20.9207 18.9062C20.4892 18.9062 20.1395 19.2566 20.1395 19.6875V19.9216C19.2637 20.1094 18.6465 20.6563 18.5059 21.4727C18.2166 23.1461 19.8023 23.6113 20.4793 23.8102L20.7063 23.8761C21.8501 24.2032 21.8313 24.3132 21.797 24.512C21.7432 24.8172 21.1489 24.8929 20.613 24.8099C20.342 24.7696 19.9954 24.6451 19.6887 24.5352L19.5142 24.4718C19.1075 24.3314 18.6614 24.5425 18.5173 24.9491C18.3739 25.3557 18.5869 25.8022 18.9939 25.9464L19.1605 26.005C19.4636 26.1139 19.8004 26.2233 20.1394 26.2984V26.5625C20.1394 26.9934 20.4891 27.3438 20.9207 27.3438C21.3522 27.3438 21.7019 26.9934 21.7019 26.5625V26.3182C22.5754 26.131 23.1945 25.5944 23.3359 24.778C23.627 23.0859 22.0059 22.6211 21.1348 22.375Z"
            fill="url(#paint0_linear_1551_18584)"
          />
          <rect x="0.919922" y="0.5" width="39" height="39" rx="7.5" stroke="white" strokeOpacity="0.01" />
        </g>
        <defs>
          <filter
            id="filter0_b_1551_18584"
            x="-70.5801"
            y="-71"
            width="182"
            height="182"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1551_18584" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1551_18584" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_1551_18584"
            x1="13.4199"
            y1="30"
            x2="33.3544"
            y2="21.2783"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DC8ED" />
            <stop offset="1" stopColor="#548AF0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: 1,
    title: 'Invoice Discounting',
    image: () => (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_1551_18590)">
          <rect x="0.419922" width="40" height="40" rx="8" fill="white" fillOpacity="0.04" />
          <path
            d="M29.1699 26H12.9199V12.2148C12.9199 11.5598 12.3602 11 11.6699 11C10.9797 11 10.4199 11.5598 10.4199 12.2148V27.25C10.4199 27.9375 10.9824 28.5 11.6699 28.5H29.1699C29.8613 28.5 30.4199 27.9414 30.4199 27.25C30.4199 26.5586 29.8613 26 29.1699 26ZM14.7598 15.3398C14.3066 15.8633 14.3066 16.6562 14.7598 17.1406L17.6262 20.007C18.1145 20.4953 18.9055 20.4953 19.3938 20.007L22.2949 17.1445L24.7191 19.5688L23.1027 21.1852C22.709 21.5781 22.9863 22.25 23.5449 22.25H28.5449C28.8901 22.25 29.1699 21.9702 29.1699 21.625V16.625C29.1699 16.1047 28.5211 15.7648 28.1031 16.1832L26.4867 17.7996L23.1785 14.4914C22.9355 14.2461 22.6152 14.125 22.2949 14.125C21.9746 14.125 21.6551 14.2471 21.4113 14.4912L18.5449 17.3594L16.5625 15.377C16.0762 14.8867 15.2832 14.8867 14.7598 15.3398Z"
            fill="url(#paint0_linear_1551_18590)"
          />
          <rect x="0.919922" y="0.5" width="39" height="39" rx="7.5" stroke="white" strokeOpacity="0.01" />
        </g>
        <defs>
          <filter
            id="filter0_b_1551_18590"
            x="-70.5801"
            y="-71"
            width="182"
            height="182"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1551_18590" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1551_18590" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_1551_18590"
            x1="10.4199"
            y1="28.5"
            x2="32.3428"
            y2="13.8841"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DC8ED" />
            <stop offset="1" stopColor="#548AF0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: 2,
    title: 'Reverse Factoring',
    image: () => (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_1551_18596)">
          <rect x="0.419922" width="40" height="40" rx="8" fill="white" fillOpacity="0.04" />
          <g clipPath="url(#clip0_1551_18596)">
            <path
              d="M13.7533 21.559C13.7533 21.1368 13.9259 20.7316 14.2269 20.4476L16.7314 18.0837C16.7887 18.0297 16.8624 18.0034 16.9262 17.9594C16.5692 17.1389 15.8019 16.5556 14.8644 16.5556H12.6421C11.4147 16.5556 10.4199 17.5521 10.4199 18.7778V22.1111C10.4199 22.7247 10.9175 23.2222 11.4998 23.2222L11.531 27.6667C11.531 28.2802 12.0286 28.7778 12.6421 28.7778H14.8644C15.4779 28.7778 15.9755 28.2802 15.9755 27.6667V24.3198L14.2269 22.6694C13.8956 22.3854 13.7533 21.9792 13.7533 21.559ZM27.0866 15.4444C28.3151 15.4444 29.3088 14.4507 29.3088 13.2222C29.3088 11.9938 28.3151 11 27.0866 11C25.8581 11 24.8644 11.9938 24.8644 13.2222C24.8644 14.4507 25.8574 15.4444 27.0866 15.4444ZM13.7533 15.4444C14.9817 15.4444 15.9755 14.4507 15.9755 13.2222C15.9755 11.9938 14.9824 11 13.7533 11C12.5241 11 11.531 11.9938 11.531 13.2222C11.531 14.4507 12.5251 15.4444 13.7533 15.4444ZM25.8505 21.2535L23.347 18.8924C23.2258 18.778 23.0482 18.7468 22.8953 18.8125C22.7428 18.8785 22.6421 19.0278 22.6421 19.1944V20.4444H18.1977V19.1944C18.1977 19.028 18.0985 18.8773 17.9455 18.8115C17.7915 18.7465 17.6144 18.7465 17.4928 18.8924L14.9894 21.2535C14.8225 21.4109 14.8225 21.7028 14.9894 21.8601L17.4935 24.2236C17.6147 24.3379 17.7924 24.3691 17.9453 24.3034C18.097 24.2396 18.1977 24.0868 18.1977 23.9201V22.6667H22.6421V23.9215C22.6421 24.088 22.7413 24.2387 22.8943 24.3049C23.0473 24.3706 23.225 24.3393 23.346 24.225L25.8502 21.8615C26.0171 21.7049 26.0171 21.4132 25.8505 21.2535ZM28.1977 16.5556H25.9755C25.0692 16.5556 24.2401 17.1378 23.9137 17.959C23.9776 18.0032 24.0515 18.0294 24.1089 18.0836L26.6131 20.4468C26.913 20.7292 27.0866 21.1354 27.0866 21.559C27.0867 21.9813 26.9141 22.3865 26.613 22.6705L24.8644 24.3194V27.6667C24.8644 28.2802 25.3619 28.7778 25.9755 28.7778H28.1977C28.8112 28.7778 29.3088 28.2802 29.3088 27.6667V23.2222C29.9224 23.2222 30.4199 22.7247 30.4199 22.1111V18.7778C30.4199 17.5521 29.4234 16.5556 28.1977 16.5556Z"
              fill="url(#paint0_linear_1551_18596)"
            />
          </g>
          <rect x="0.919922" y="0.5" width="39" height="39" rx="7.5" stroke="white" strokeOpacity="0.01" />
        </g>
        <defs>
          <filter
            id="filter0_b_1551_18596"
            x="-70.5801"
            y="-71"
            width="182"
            height="182"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1551_18596" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1551_18596" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_1551_18596"
            x1="10.4199"
            y1="28.7778"
            x2="32.5539"
            y2="14.2517"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DC8ED" />
            <stop offset="1" stopColor="#548AF0" />
          </linearGradient>
          <clipPath id="clip0_1551_18596">
            <rect width="20" height="20" fill="white" transform="translate(10.4199 10)" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    id: 3,
    title: 'Trade Payables Financing',
    image: () => (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_1551_18601)">
          <rect x="0.419922" width="40" height="40" rx="8" fill="white" fillOpacity="0.04" />
          <path
            d="M28.4199 15H23.4199V10L28.4199 15ZM23.4199 16.25H28.4199V28.125C28.4199 29.1605 27.5805 30 26.5449 30H15.2949C14.2594 30 13.4199 29.1602 13.4199 28.125V11.875C13.4199 10.8395 14.2594 10 15.2949 10H22.1699L22.1701 15C22.1699 15.6914 22.7285 16.25 23.4199 16.25ZM15.9199 13.4375C15.9199 13.6086 16.0617 13.75 16.2324 13.75H19.3574C19.5293 13.75 19.6699 13.6086 19.6699 13.4375V12.8125C19.6699 12.6418 19.5293 12.5 19.3574 12.5H16.2324C16.0617 12.5 15.9199 12.6418 15.9199 12.8125V13.4375ZM16.2324 16.25H19.3574C19.5293 16.25 19.6699 16.1094 19.6699 15.9375V15.3125C19.6699 15.1406 19.5293 15 19.3574 15H16.2324C16.0617 15 15.9199 15.1406 15.9199 15.3125V15.9375C15.9199 16.1094 16.0617 16.25 16.2324 16.25ZM21.1348 22.375L20.8848 22.3125C19.9941 22.0391 20.0137 21.8789 20.0449 21.7383C20.0986 21.4331 20.693 21.3586 21.2273 21.4404C21.4459 21.4734 21.6855 21.5503 21.9145 21.6296C22.3203 21.77 22.7672 21.5539 22.9086 21.1476C23.0502 20.7398 22.8347 20.2945 22.427 20.1527C22.145 20.0557 21.9148 19.9934 21.702 19.9467V19.6875C21.702 19.2566 21.3522 18.9062 20.9207 18.9062C20.4892 18.9062 20.1395 19.2566 20.1395 19.6875V19.9216C19.2637 20.1094 18.6465 20.6563 18.5059 21.4727C18.2166 23.1461 19.8023 23.6113 20.4793 23.8102L20.7063 23.8761C21.8501 24.2032 21.8313 24.3132 21.797 24.512C21.7432 24.8172 21.1489 24.8929 20.613 24.8099C20.342 24.7696 19.9954 24.6451 19.6887 24.5352L19.5142 24.4718C19.1075 24.3314 18.6614 24.5425 18.5173 24.9491C18.3739 25.3557 18.5869 25.8022 18.9939 25.9464L19.1605 26.005C19.4636 26.1139 19.8004 26.2233 20.1394 26.2984V26.5625C20.1394 26.9934 20.4891 27.3438 20.9207 27.3438C21.3522 27.3438 21.7019 26.9934 21.7019 26.5625V26.3182C22.5754 26.131 23.1945 25.5944 23.3359 24.778C23.627 23.0859 22.0059 22.6211 21.1348 22.375Z"
            fill="url(#paint0_linear_1551_18601)"
          />
          <rect x="0.919922" y="0.5" width="39" height="39" rx="7.5" stroke="white" strokeOpacity="0.01" />
        </g>
        <defs>
          <filter
            id="filter0_b_1551_18601"
            x="-70.5801"
            y="-71"
            width="182"
            height="182"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1551_18601" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1551_18601" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_1551_18601"
            x1="13.4199"
            y1="30"
            x2="33.3544"
            y2="21.2783"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DC8ED" />
            <stop offset="1" stopColor="#548AF0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    id: 4,
    title: 'Inventory Financing',
    image: () => (
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_1551_18607)">
          <rect x="0.419922" width="40" height="40" rx="8" fill="white" fillOpacity="0.04" />
          <path
            d="M22.9199 15H12.9199C11.5391 15 10.4199 16.1191 10.4199 17.5V27.5C10.4199 28.8805 11.5391 30 12.9199 30H22.9199C24.3008 30 25.4199 28.8805 25.4199 27.5V17.5C25.4199 16.2383 24.3926 15 22.9199 15ZM22.9199 20H12.9199V17.5H22.9199V20ZM27.9199 10H17.9199C16.5391 10 15.4199 11.1191 15.4199 12.4648V13.125H17.9199V12.5H27.9199V22.5H27.2949V25L27.9199 25C29.3008 25 30.4199 23.8805 30.4199 22.5V12.5C30.4199 11.1191 29.2988 10 27.9199 10Z"
            fill="url(#paint0_linear_1551_18607)"
          />
          <rect x="0.919922" y="0.5" width="39" height="39" rx="7.5" stroke="white" strokeOpacity="0.01" />
        </g>
        <defs>
          <filter
            id="filter0_b_1551_18607"
            x="-70.5801"
            y="-71"
            width="182"
            height="182"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="35.5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1551_18607" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1551_18607" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_1551_18607"
            x1="10.4199"
            y1="30"
            x2="34.0467"
            y2="16.2171"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2DC8ED" />
            <stop offset="1" stopColor="#548AF0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
];

const SolutionsSection = () => {
  const { width } = useWindowSize();

  return (
    <section className="solutions-section">
      <div className="solutions-section__vector">
        <img src="/images/main/logisticsFinance/solutions/7.webp" alt="Logistic solutions" />
      </div>
      <div className="container">
        <h2 className="solutions-section__title-h2">
          <img
            src="/images/main/logisticsFinance/solutions/6.svg"
            alt="Design line"
            className="solutions-section__title-image"
          />
          Financing {width > 768 && <br />} Solutions
        </h2>
        {financeSolutionsCards.map((item, index) => (
          <div className={`solutions-section-card card${index + 1}`} key={item.id}>
            {item.image()}
            {item.title}
          </div>
        ))}
      </div>
    </section>
  );
};

export default SolutionsSection;
